import { getDescriptor } from './ComponentRegistry';

const NAMED_TYPES = new Set([
  'stack', 'columns', 'header', 'footer', 'contentBody', 'floating', 'section',
  'products', 'facets', 'history', 'suggestions', 'catSuggestions', 'categories',
  'pills', 'sort', 'pagination', 'filtersButton', 'fallbackWarning', 'noResults',
  'didYouMean', 'text', 'imageDropzone', 'viewAll', 'popularQueries',
]);

/** Customer-facing names shared by outline, library, preview and inspector. */
export const componentLabel = (type, t) => {
  if (NAMED_TYPES.has(type)) return t(`experience.blocks.${type}`);
  const descriptor = getDescriptor(type);
  return descriptor?.displayName || descriptor?.label || type.replace(/([a-z])([A-Z])/g, '$1 $2');
};
